import httpClient from "@/utils/httpClient";

export const getAllEmployees = async (page = 1, limit = 20, filters = {}) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    // Add filters if they exist
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }

    const response = await httpClient.get(`/hr/employees?${params.toString()}`);

    return {
      success: true,
      data: response.data || [],
      pagination: response.pagination || null,
      error: null
    };
  } catch (error) {
    console.error("getAllEmployees API Error:", error);
    return {
      success: false,
      data: null,
      pagination: null,
      error: { message: error.message || 'Failed to fetch employees' }
    };
  }
};

export const getEmployeeById = async (id) => {
  try {
    const response = await httpClient.get(`/hr/employees/${id}`);
    
    return {
      success: true,
      data: response.data || response,
      error: null
    };
  } catch (error) {
    console.error("getEmployeeById API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Employee not found' }
    };
  }
};

export const addEmployee = async (employeeData) => {
  try {
    // Validate required fields based on database schema
    const requiredFields = ['name', 'email'];
    const missingFields = requiredFields.filter(field => !employeeData[field]);
    
    if (missingFields.length > 0) {
      return {
        success: false,
        data: null,
        error: { message: `Missing required fields: ${missingFields.join(', ')}` }
      };
    }

    const response = await httpClient.post('/hr/employees', employeeData);
    
    return {
      success: true,
      data: response.data || response,
      error: null
    };
  } catch (error) {
    console.error("addEmployee API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to add employee' }
    };
  }
};

export const updateEmployee = async (id, employeeData) => {
  try {
    const response = await httpClient.put(`/hr/employees/${id}`, employeeData);
    
    return {
      success: true,
      data: response.data || response,
      error: null
    };
  } catch (error) {
    console.error("updateEmployee API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to update employee' }
    };
  }
};

export const deleteEmployee = async (id) => {
  try {
    const response = await httpClient.delete(`/hr/employees/${id}`);

    return {
      success: true,
      data: response.data || { id: parseInt(id) },
      error: null
    };
  } catch (error) {
    console.error("deleteEmployee API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to delete employee' }
    };
  }
};

export const getAllDepartments = async () => {
  try {
    const response = await httpClient.get('/hr/employees/departments/list');

    return {
      success: true,
      data: response.data || [],
      error: null
    };
  } catch (error) {
    console.error("getAllDepartments API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to fetch departments' }
    };
  }
};

export const getAllEmployeesWithoutPagination = async (filters = {}) => {
  try {
    const params = new URLSearchParams({
      // No pagination parameters - fetch all
      noPagination: 'true'
    });

    // Add filters if they exist
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }

    const response = await httpClient.get(`/hr/employees?${params.toString()}`);

    return {
      success: true,
      data: response.data || [],
      error: null
    };
  } catch (error) {
    console.error("getAllEmployeesWithoutPagination API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to fetch all employees' }
    };
  }
};

export const getEmployeeProfile = async (id) => {
  try {
    const response = await httpClient.get(`/hr/employees/${id}/profile`);

    return {
      success: true,
      data: response.data || response,
      error: null
    };
  } catch (error) {
    console.error("getEmployeeProfile API Error:", error);
    return {
      success: false,
      data: null,
      error: { message: error.message || 'Failed to fetch employee profile' }
    };
  }
};
